/* eslint-disable max-classes-per-file */

import extractErrorMessageFromResponse from 'core/axios/extractErrorMessageFromResponse';

const ErrorCode = {
  BAD_REQUEST: ['BAD_REQUEST', 'Invalid input.'],
  UNAUTHORIZED: ['UNAUTHORIZED', 'Incorrect authentication credentials.'],
  FORBIDDEN: ['FORBIDDEN', "You don't have permission to perform this action."],
  NOT_FOUND: ['NOT_FOUND', 'Not found.'],
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
  INTERNAL_SERVER_ERROR: ['INTERNAL_SERVER_ERROR', 'A server error occurred.'],
  NETWORK_ERROR: ['NETWORK_ERROR', 'Connection lost. Try reloading this page.'],
  UNKNOWN_ERROR: ['UNKNOWN_ERROR', 'An unknown error occurred.'],
};

export const ERROR_STATUS_CODE_MAP = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
};

const HTTPStatusCode = {
  [ERROR_STATUS_CODE_MAP.BAD_REQUEST]: ErrorCode.BAD_REQUEST,
  [ERROR_STATUS_CODE_MAP.UNAUTHORIZED]: ErrorCode.UNAUTHORIZED,
  [ERROR_STATUS_CODE_MAP.FORBIDDEN]: ErrorCode.FORBIDDEN,
  [ERROR_STATUS_CODE_MAP.NOT_FOUND]: ErrorCode.NOT_FOUND,
  [ERROR_STATUS_CODE_MAP.TOO_MANY_REQUESTS]: ErrorCode.TOO_MANY_REQUESTS,
  [ERROR_STATUS_CODE_MAP.INTERNAL_SERVER_ERROR]:
    ErrorCode.INTERNAL_SERVER_ERROR,
};

export class APIError extends Error {
  constructor(message, errorCode, statusCode, response) {
    super(message);
    this.errorCode = errorCode;
    this.statusCode = statusCode;
    this.response = response;
  }
}

export class NetworkError extends Error {
  constructor() {
    const [errorCode, message] = ErrorCode.NETWORK_ERROR;
    super(message);
    this.errorCode = errorCode;
  }
}

export default function handleError(error) {
  if (error.response) {
    const { data, status: statusCode } = error.response;
    let message;
    let defaultMessage;
    let errorCode;

    if (statusCode in HTTPStatusCode) {
      [errorCode, defaultMessage] = HTTPStatusCode[statusCode];
      const responseError = extractErrorMessageFromResponse(data);
      message =
        data?.detail ||
        data?.nonFieldErrors?.[0] ||
        data?.error ||
        responseError?.message ||
        defaultMessage;
    } else {
      [errorCode, message] = ErrorCode.UNKNOWN_ERROR;
    }

    throw new APIError(message, errorCode, statusCode, data);
  }

  throw new NetworkError();
}
